import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RegistrationPage from "./pages/RegistrationPage";
import Header from "./components/common/Header";
import Layout from "./components/common/Layout";
import { Toaster } from "react-hot-toast";
import AdminPanel from "./pages/AdminPage";

const App: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Header />
        <Routes>
          <Route path="/" element={<RegistrationPage />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
        <Toaster position="top-right" />
      </Layout>
    </Router>
  );
};

export default App;
